import { render, staticRenderFns } from "./DeviceActionsComponent.vue?vue&type=template&id=0e80a50e&scoped=true&"
import script from "./DeviceActionsComponent.vue?vue&type=script&lang=js&"
export * from "./DeviceActionsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e80a50e",
  null
  
)

export default component.exports